// src/config/booking.js
//
// BLANK-but-valid scaffold (Slice 1 de-seed). The SHAPE is the structural fallback used
// before Danielle fills /siteContent/booking (booking page copy + manual-payment details)
// via the admin Booking / Payment editor. NO demo data: empty strings, no PayMe handle /
// FPS number, no session prices. Danielle sets every value herself.
export const DEFAULT_BOOKING = {
    pageTagline: '',
    pageTitle: '',
    pageSubtitle: '',
    oneOnOneLabel: '',
    oneOnOnePrice: '',
    oneOnOneDuration: '',
    oneOnOneDurationSummary: '',
    oneOnOneDescription: '',
    smallGroupLabel: '',
    smallGroupMaxSize: '',
    smallGroupPrice: '',
    smallGroupDuration: '',
    smallGroupDurationSummary: '',
    smallGroupDescription: '',
    zoomNote: '',
    cancellationPolicy: '',
    confirmationTitle: '',
    confirmationMessage: '',

    // WhatsApp settings
    whatsappNumber: '',
    whatsappDisplayName: '',
    whatsappBoundaryNote: '',

    // PayMe / FPS settings
    paymeHandle: '',
    paymeQrImageUrl: '',
    fpsNumber: ''
};
